import useLazyData, { IPrimaryKeys } from './useLazyData';
import { getGameInfoByIdPlus } from '@intelligence/services/common';

const STATIC_PARAMS: IGameDetailsFetchConfig = {
  entity_type: 'mobile',
  level: 'custom',
  custom_fields: [
    'country_abbre',
    'publisher',
    'publisher_country_abbre',
    'publisher_country_name_en',
    'b_ogdb_data',
    'iegg_genre',
    'iegg_sub_genre',
    'genre',
    'sub_genre',
    'sensortower_genre',
    'sensortower_sub_genre',
    'is_special_release_time',
    'release_time',
    'release_time_en',
    'release_time_cn',
    'sensortower_tag',
  ],
};

const fetchGameDetailsData = (ids?: IPrimaryKeys | null, config?: IGameDetailsFetchConfig) => {
  return getGameInfoByIdPlus({ ...STATIC_PARAMS, ...config, ids: ids || [] });
};

export default function useGameDetailsLazyData(props?: {
  entityType?: IEntityType;
  level?: IGameDetailsFetchConfig['level'];
  fields?: IGameDetailsFetchConfig['custom_fields'];
}) {
  const {
    entityType = STATIC_PARAMS.entity_type,
    level = STATIC_PARAMS.level,
    fields = STATIC_PARAMS.custom_fields,
  } = props || {};

  return useLazyData({
    fetchDetailsData: (ids?: IPrimaryKeys | null) => {
      return fetchGameDetailsData(ids, { entity_type: entityType, level, custom_fields: fields });
    },
  });
}
